<template>
    <tree id="vueTreeRoot" v-if="tree" :tree-data.sync="tree" :activeNode="activeNode" :data-reload="reloadTree"></tree>
</template>

<script>
import Tree from './tree'
import * as treeviewApi from 'api/treeviewOldApi.js'

export default {
  data () {
    return {
      activeNode: JSON.parse(localStorage.getItem('selectedFolderId')),
      menuOpen: false,
      tree: [],
      reloadTree: 0, // indicates if the folder tree should be reloaded when clicking on a document
      staticTree: {
        Id: 1,
        level: 1,
        Name: 'Kantoor',
        root: true,
        addData: 10,
        workbox: false,
        children: [
          {
            Id: 2,
            level: 2,
            Name: 'Standaard projecten',
            template: true,
            editable: true,
            hasFavorite: true,
            favorite: false,
            addDate: 8,
            workbox: false,
            children: [
              {
                Id: 3,
                level: 3,
                Name: 'AFAS',
                template: true,
                isWritable: true,
                favorite: false,
                addDate: 8,
                workbox: false
              },
              {
                Id: 4,
                level: 3,
                Name: 'Algemene administratie',
                isWritable: true,
                favorite: false,
                hasFavorite: true,
                addDate: 8,
                workbox: false,
                children: [
                  {
                    Id: 5,
                    level: 4,
                    favorite: true,
                    isFavorite: true,
                    Name: 'FAVORITE',
                    addDate: 8,
                    workbox: false
                  },
                  {
                    Id: 6,
                    level: 4,
                    favorite: false,
                    Name: 'bouwplannen',
                    addDate: 3,
                    workbox: false
                  }
                ]
              },
              {
                Id: 7,
                level: 3,
                favorite: false,
                editable: true,
                Name: 'Allhands Q2 2019',
                addDate: 1,
                workbox: false
              }
            ]
          },
          {
            Id: 10,
            level: 2,
            Name: 'Lekkere sjablonen',
            project: true,
            favorite: false,
            addDate: 8,
            workbox: false,
            children: [
              {
                Id: 11,
                level: 3,
                favorite: false,
                isWritable: true,
                isConfIdential: true,
                Name: 'Laatste versie',
                addDate: 1,
                workbox: false
              }
            ]
          },
          {
            Id: 12,
            level: 2,
            Name: 'Nieuwe project',
            favorite: true,
            isFavorite: true,
            project: true,
            new: true,
            addDate: 8,
            workbox: false
          },
          {
            Id: 13,
            level: 2,
            Name: 'Prullenbak',
            trash: true,
            favorite: false,
            workbox: false
          }
        ]
      }
    }
  },
  components: {
    Tree
  },
  created () {
    this.loadData()
    this.$eventBus.$on('updateNodes', (node) => {
      if (this.activeNode !== node) {
        this.activeNode = node
      }
    })
    function windowMousemove (e) {
      // Prevent default event
      e.preventDefault()
      // Call mouseMove
      parent.mouseMove(e, 'navbar', 'tree', false)
    }
    function windowMouseup (e) {
      // Prevent default event
      e.preventDefault()
      // Call mouseUp
      parent.mouseUp()
    }
    function activateMouseEvents (type) {
      // Bind mousemove event
      window.addEventListener('mousemove', windowMousemove)

      // Bind mouseup event
      window.addEventListener('mouseup', windowMouseup)
    }

    function deactivateMouseEvents () {
      window.removeEventListener('mousemove', windowMousemove)
      window.removeEventListener('mouseup', windowMouseup)
    }
    window.parent.frames.tree = {
      activateMouseEvents: activateMouseEvents,
      deactivateMouseEvents: deactivateMouseEvents
    }
    this.$store.commit('setUpdateRightView', false)
  },
  mounted () {
    window.parent.tree.forceRerender = this.forceRerender
  },
  methods: {
    forceRerender () {
      window.location.reload()
    },
    loadData () {
      let self = this
      return treeviewApi.loadChildrenFolders(-1).then(folders => {
        let rootHasSubfolders = false
        let children = null

        if (folders.length > 0) rootHasSubfolders = true
        // check if loadChildrenFolders response is a path in the folder tree
        if (this.responseHasDepth(folders)) {
          self.reloadTree = 1 // set flag to reload tree on document clicks
          // convert folders to a path in the tree to the selected document
          children = this.buildFolderTree(folders)
        } else {
          children = folders
        }
        treeviewApi.loadRootName().then(name => {
          if (name === 'dev') name = this.$i18n.t('treeView.rootFolderName')
          this.tree = [{
            Id: -1,
            Name: name,
            root: true,
            HasSubfolders: rootHasSubfolders,
            children: children
          }]
        })
      })
    },
    responseHasDepth (folders) {
      return folders.filter(x => x.Depth > 0).length !== 0
    },
    buildFolderTree (folders) {
      let idx = folders.length
      let res = []
      let path = [-1]

      while (--idx >= 0) {
        let currentChild = folders[idx]
        path.push(currentChild.Id)
        if (idx > 0) {
          let nextChild = folders[idx - 1]
          currentChild.children = [nextChild]
        } else {
          if (idx === 0) { // leaf folder of the tree => no children
            currentChild.children = []
          }
        }
        res.push(currentChild)
      }
      // set in vuex the path in the tree
      this.$store.commit('setFolderPath', path)
      return [res[0]]
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/treeViewOldApi/treeView.vue